// Lightweight collection prefetcher.
// Previous version crawled every page of every collection (Web Worker + full
// recursive fetch) and stored all product HTML in sessionStorage.  That was
// tightly coupled to the "auto-load-all" section script that has been removed.
//
// This replacement only adds <link rel="prefetch"> hints for collection pages
// that are visible on screen, letting the browser download page 1 of up to
// three collections silently in the background.  No sessionStorage, no Worker.

window.AvCollection = null; // stub: nothing references this anymore

(function () {
  if (!('IntersectionObserver' in window)) return;

  function startWatching() {
    var seen  = {};
    var count = 0;
    var MAX   = 3;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (count >= MAX) return;
        try {
          var url = new URL(entry.target.href);
          // Only prefetch collection pages, not paginated sub-pages.
          if (!url.pathname.includes('/collections/')) return;
          if (url.search.includes('page='))           return;
          var key = url.pathname + url.search;
          if (seen[key]) return;
          seen[key] = true;
          count++;
          var link   = document.createElement('link');
          link.rel   = 'prefetch';
          link.href  = entry.target.href;
          link.as    = 'document';
          // Belt-and-suspenders: Chrome already treats prefetch as lowest
          // priority, but this reinforces it on browsers that honor it.
          link.setAttribute('fetchpriority', 'low');
          document.head.appendChild(link);
        } catch (e) {}
      });
    }, { rootMargin: '0px 0px 300px 0px' });

    document.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
      try {
        if (!new URL(a.href).search.includes('page=')) observer.observe(a);
      } catch (e) {}
    });
  }

  // Only start once the current page's own critical/eager resources (fonts,
  // CSS, above-the-fold images, hero video) have finished loading. Starting
  // on a flat setTimeout instead can fire while the visitor is still
  // scrolling the home page and its own lazy images are actively being
  // requested — the prefetch documents (and any eager images they preload
  // scan for) would then compete for the same HTTP/2 connection pool and
  // visibly slow down or stall in-page image loads.
  function schedule() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(startWatching, { timeout: 4000 });
    } else {
      setTimeout(startWatching, 2000);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
  }
}());
